import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    LineChart,
	Line,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceLine,
    Cell,
    Legend
  } from "recharts";
  import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';
  import ConfirmationDialog from "Routes/common/ConfirmationDialog";
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';
import moment from 'moment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { 
    fetchOCTApproachChart,
    fetchApproachShotChart,
    deleteOCTApproach,
   fetchOCTApproach,
   studentOCTApproach,
 } from 'Actions';

 import AddItem from '../../../oncoursetest/approach/component/addform';
 import EditItem from '../../../oncoursetest/approach/component/editform';

class ApproachChart extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
    };

    
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            distance:'',
            area:'',
            contact:'',
            shotstring:'',
            loader:false,
            showModal:false,  
            viewdiv:true,  
            frm:this.props.data.frm,
            adddiv:false,
            viewdiv:true,
            listdiv:false,
            editdiv:false,
            sepmore:1,
            formValues: [{ distance:"", right : "", left : "", short : "", long : "", area:"", contact:"", putt : "", missedgreen : "0",  disright:"", disleft:"", disshort:"", dislong:""}],
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.onEditBack = this.onEditBack.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.viewList = this.viewList.bind(this);
    }

    handleChange(e, val){

        if(val==1){
            var distance=e.target.value;
            var area=this.state.area;
            var contact=this.state.contact;
            this.setState({ distance:distance });
        }else if(val==2){
            var area=e.target.value;
            var distance=this.state.distance;
            var contact=this.state.contact;
            this.setState({ area:area });
        }else if(val==3){
            var contact=e.target.value;
            var area=this.state.area;
            var distance=this.state.distance;
            this.setState({ contact:contact });
        }
        
        var student=this.state.student;
        if(this.state.startdate==''){
            var stdate=""; 
        }else{    
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if(this.state.enddate==''){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        this.props.fetchOCTApproachChart(student, stdate, eddate, distance, area, contact).then((data) => {   
           

        }); 
    }

    shotpercentage(section){
        if(section==1){
            var shotstring='AVG DISPERSION';
        }else if(section==2){
            var shotstring='UP & DOWN';
        }else if(section==3){
            var shotstring='GOOD CONTACT';
        }else if(section==4){
            var shotstring='BAD CONTACT';
        }
        this.setState({ shotstring:shotstring});
        var student=this.state.student;
        var contact=this.state.contact;
        var area=this.state.area;
        var distance=this.state.distance;
        if(this.state.startdate==''){
            var stdate=""; 
        }else{    
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if(this.state.enddate==''){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        
        this.props.fetchApproachShotChart(student, stdate, eddate, distance, area, contact, section).then((data) => {   
                        
            this.setState({ showModal:true});

        }); 
    }

    addEntry(){
        this.setState({ 
            adddiv:true,
            viewdiv:false,
       });
    }

    viewList(){
        var stdid=this.state.student;
        var start='';
        var end='';
        this.props.studentOCTApproach(stdid, start, end).then((data) => {   
            
            this.setState({ 
                viewdiv:false,
                listdiv:true
            });

        });
        
    }

    onBackSection() {
		this.setState({ 
            adddiv:false,
            listdiv:false,
            viewdiv:true,
       });
	}
    
    onEditBack() {
		this.setState({ 
            adddiv:false,
            editdiv:false,
            listdiv:false,
            viewdiv:true,
       });
	}  

    editAssessment(assmval){
        
        var id=assmval.goca_userID;
        var date=assmval.goca_date;
          
          this.props.fetchOCTApproach(id, date).then((data) => {   
           var resdata=data.data;
           var troptobj=[]; 
           {resdata.map((teamval) => (   
              troptobj.push({
                 distance: teamval.goca_shot,
                 right: teamval.goca_right,
                 left: teamval.goca_left,
                 short: teamval.goca_short,
                 long: teamval.goca_long,
                 area: teamval.goca_area,
                 contact:teamval.goca_contact,
                 putt: teamval.goca_putt,
                 missedgreen:teamval.goca_dhg,
                 disright:teamval.goca_right==0 ? 0 : 1, 
                 disleft:teamval.goca_left==0 ? 0 : 1, 
                 disshort:teamval.goca_short==0 ? 0 : 1, 
                 dislong:teamval.goca_long==0 ? 0 : 1, 
              })
           ))} 
           this.setState({ 
              seldate:resdata[0].goca_date, 
              student:resdata[0].goca_userID,
              formValues:troptobj,
              sepmore:resdata.length
           });
  
              this.setState({ 
                  viewdiv:false, 
                  listdiv:false,              
                  adddiv:false,
                  editdiv:true,
              });
  
          });
      }
  
      deleteForm(assmval){
        this.id = assmval.goca_userID;
        this.date = assmval.goca_date;
        this.confirmationDialog.current.openDialog();
      }
  
     deleteDataPermanent(popupResponse){
        
          if (popupResponse) {
              this.props.deleteOCTApproach(this.id, this.date);
              this.data = ""
          }
     }
    


render() {

    const { approachchart, approachshotchart, playerinterventionlist, octapproachlist, loading} = this.props; 
    const datacount=approachchart.length;
    const scatterData = approachchart.chartvalue;  
    const linedata = approachshotchart.chartval;
    const linemax = approachshotchart.highval;
    const data1 = [
        { x: 'ON TARGET', y: approachchart.ontarget },
        { x: 'RIGHT', y: approachchart.missright },
        { x: 'LEFT', y: approachchart.missleft },
        { x: 'LONG', y: approachchart.misslong },
        { x: 'SHORT', y: approachchart.missshot },
        { x: 'OUTSIDE', y: approachchart.outside },
    ];  
    const data1max=approachchart.highval;  

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip" style={{backgroundColor:"#fff", padding:"10px", fontSize:"10px"}}>
              <div className="label" style={{fontSize:"13px"}}>{`${payload[0].payload?.label1}`}=<strong>{`${payload[0].payload?.val1}`}</strong></div>
              <div className="label" style={{fontSize:"13px"}}>{`${payload[0].payload?.label2}`}=<strong>{`${payload[0].payload?.val2}`}</strong></div>
            </div>
          );
        }
      
        return null;
    };

    const CustomBarLabel = ({ payload, x, y, value }) => {
        return <text x={x+10} y={y} dy={-6} fill="#757474" textAnchor="middle" >{value}%</text>;
      }

      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "name", label: "NAME" },
        { name: "cdate", label: "DATE" },
        { name: "action", label: "EDIT" },
        { name: "action1", label: "DELETE" },
      
    ];
    const tabledata=octapproachlist.map((assmntval,idx) => {     
           const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
           const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
            no:idx+1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: ebtn,
            action1:dbtn,
            
            }
    }); 

    return(
        <div>   
                {this.state.viewdiv && 
                <RctCollapsibleCard>
                <div className="row">
                    <div className="col-sm-12 col-lg-3">
                        <h2>ON COURSE APPROACH REPORT</h2>   
                        <div className=""><strong>Total : {approachchart.totalrow}</strong></div>                     
                    </div>
                    <div className="col-sm-12 col-lg-9">
                        <div className="row">
                            <div className="col-sm-12 col-lg-1">
                                <h5>Distance Hole</h5>
                            </div>    
                            <div className="col-sm-12 col-lg-3">                        
                            <select  name="distance" id="distance" className="form-control form-control-alternative" onChange={e => this.handleChange(e,1)} required>
                                <option value="">All</option>
                                <option value="120-140">120-140</option>
                                <option value="141-160">141-160</option> 
                                <option value="161-180">161-180</option>
                                <option value="181-200">181-200</option>  
                                <option value="201-220">201-220</option>                                          
                            </select>
                            </div>
                            <div className="col-sm-12 col-lg-1">
                                <h5>Area of Play</h5>
                            </div>    
                            <div className="col-sm-12 col-lg-2">                        
                            <select  name="area" id="area" className="form-control form-control-alternative" onChange={e => this.handleChange(e,2)} required>
                                <option value="">All</option>
                                <option value="1">Fairway</option>
                                <option value="2">Rough</option>                                             
                            </select>
                            </div>
                            <div className="col-sm-12 col-lg-1">
                                <h5 style={{marginTop:"10px"}}>Contact</h5>
                            </div>    
                            <div className="col-sm-12 col-lg-2">                        
                            <select  name="contact" id="contact" className="form-control form-control-alternative" onChange={e => this.handleChange(e,3)} required>
                                <option value="">All</option>
                                <option value="1">Good</option>
                                <option value="2">Bad</option>                                            
                            </select>
                            </div>
                            <div className="col-sm-12 col-lg-2">
                                    <div><a onClick={this.addEntry} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.viewList}><span class="icon-list"></span> List</a></div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-sm-12 col-lg-12" style={{marginBottom:"20px"}}></div>
                    {datacount==0?
                     <div className="col-sm-12 col-lg-12">
                      <h2 className="text-center" style={{color:"red"}}>No Data</h2>
                     </div> 
                    :    
                    <>
                    <div className="col-sm-12 col-lg-5">
                            
                        <ScatterChart
                        width={450}
                        height={300}
                        margin={{
                            top: 30,
                            right: 50,
                            bottom: 20,
                            left: 20
                        }}
                        
                        >
                        <text x={450 / 2} y={10} fill="gray" textAnchor="top" dominantBaseline="central">
                            <tspan fontSize="14">Long</tspan>
                        </text>
                        <text x={410} y={140} fill="gray" textAnchor="right" dominantBaseline="center">
                            <tspan fontSize="14">Right</tspan>
                        </text>     
                        <CartesianGrid />
                        <XAxis type="number" tickLine={false} tick={{ fontSize: 0 }} ticks={[-80, -60, -40, -20, -10, 0, 10, 20, 40, 60, 80]} label={{value:"Short", position:"bottom"}} dataKey="x" unit="ft" /> 
                        <YAxis type="number" tickLine={false} tick={{ fontSize: 0 }} ticks={[-80, -60, -40, -20, -10, 0, 10, 20, 40, 60, 80]} label={{value:"Left", position: "insideLeft"}} dataKey="y" unit="ft" />
                        
                        <Scatter name="A school" data={scatterData} fill="#8884d8">
                            {scatterData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.fill} text="sdfdsf" label="sdfsfd" dataKey={entry}/>
                            ))}
                        </Scatter>
                        <Tooltip cursor={{ strokeDasharray: "3 3" }} content={<CustomTooltip/>}/>
                        <ReferenceLine y={0} stroke="#000000" />
                        <ReferenceLine x={0} stroke="#000000" />
                        <ReferenceLine
                            segment={[
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            }
                            ]}
                            label={{
                            value: "0",
                            position: "bottom"
                            }}
                        />
                        </ScatterChart>
                            
                    </div>
                    <div className="col-sm-12 col-lg-3">
                        <List className="p-0">
                            <ListItem>
                                <ListItemText primary="TOTAl SHOTS" /> 
                                <ListItemSecondaryAction><strong>{approachchart.totalshot}</strong> </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(1)}>
                                <ListItemText primary="AVG DISPERSION" /> 
                                <ListItemSecondaryAction><strong>{approachchart.avgdisp+' FT'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(2)}>
                                <ListItemText primary="UP & DOWN" /> 
                                <ListItemSecondaryAction><strong>{approachchart.updown+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(3)}>
                                <ListItemText primary="GOOD CONTACT" />
                                <ListItemSecondaryAction><strong>{approachchart.good+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <a onClick={() => this.shotpercentage(4)}>
                                <ListItemText primary="BAD CONTACT" /> 
                                <ListItemSecondaryAction><strong>{approachchart.bad+'%'}</strong> </ListItemSecondaryAction>
                                </a>
                            </ListItem>
                        </List>
                    </div>
                    <div className="col-sm-12 col-lg-4">
                        <ResponsiveContainer width={400} height={250} style={{margin:"1px"}}> 
                            <BarChart data={data1}>
                                <text x={400 / 2} y={5} fill="gray" textAnchor="top" dominantBaseline="central">
                                    <tspan fontSize="12">MISS VALUE</tspan>
                                </text>
                                <XAxis dataKey="x" stroke={ChartConfig.axesColor} interval={0} label={{stroke:"black"}} style={{ fontSize: '0.7rem' }}/>
                                <YAxis hide domain={[0, data1max]}  stroke={ChartConfig.axesColor} />
                                <CartesianGrid vertical={false} horizontal={false} stroke={ChartConfig.chartGridColor} />                                
                                <Bar dataKey="y" fill={"#0066b2"} label={<CustomBarLabel />} barSize={20}/> 
                            </BarChart>
                        </ResponsiveContainer>                            
                    </div>  
                    </>
                    }          
                </div>

                </RctCollapsibleCard>
                }
                {this.state.showModal && (
                    <Dialog open={this.state.showModal} onClose={() => this.setState({ showModal: false })} PaperProps={{ style: { width: 576 } }}>
                        <DialogTitle>
                            <div disableTypography style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>{this.state.shotstring}</span>
                                <CloseIcon onClick={() => this.setState({ showModal: false })} style={{ cursor: 'pointer' }} />
                            </div>
                        </DialogTitle>
                        <DialogContent >
                            <ResponsiveContainer width='100%' height={300}>
                                <LineChart data={linedata}>
                                    <XAxis dataKey="x" domain={[0, "auto"]} stroke={ChartConfig.axesColor} />
                                    <YAxis stroke={ChartConfig.axesColor} domain={[0, linemax]}/>
                                    <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
                                    <Tooltip wrapperStyle={tooltipStyle} cursor={false} itemStyle={tooltipTextStyle} labelStyle={{ display: 'none' }} />
                                                                    
                                    <Line type="bumpX" dataKey="y" stroke={ChartConfig.color.info} label={{ fill: '#757474', fontSize: 15, position:'top' }} dot={{ strokeWidth: 4 }} activeDot={{ r: 10 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </DialogContent>
                        
                    </Dialog>
                )}

                {this.state.adddiv&&
                 <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.listdiv &&
                    <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="ON COURSE APPROACH LIST" fullBlock>
                            <MUIDataTable    
                                    title={<div><Button onClick={ ()=>this.onBackSection()} className="btn btn-outline-warning"> Back</Button></div>}                               
                                    data={tabledata}
                                    columns={columns}
                                    options={options} 
                            />   
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.editdiv && 
                  <EditItem onClick={this.onEditBack} data={this.state}/>              
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'approach test'}
                />

                
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ octapproach, playerintervention}) => {
    const { approachchart, approachshotchart, octapproachlist, loading } = octapproach;
    const { playerinterventionlist } = playerintervention;
    return { approachchart, approachshotchart, playerinterventionlist, octapproachlist, loading };
   
}


export default connect(mapStateToProps, {
    fetchOCTApproachChart,
    fetchApproachShotChart,
    deleteOCTApproach,
   fetchOCTApproach,
   studentOCTApproach,
})(ApproachChart);
